module.exports = __webpack_public_path__ + "img/CRT_Bow 001.7635199b.png";